var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils.js';
import { AlertAction, AlertDescription, AlertTitle, Alert as ShadcnAlert, } from './primitives/alert';
var alertVariants = cva('', {
    variants: {
        variant: {
            default: 'bg-card text-card-foreground',
            destructive: 'text-danger-foreground bg-destructive/5 *:[svg]:text-current *:data-[slot=alert-description]:text-danger-foreground border-destructive',
            success: 'text-success-foreground bg-success/5 *:[svg]:text-current *:data-[slot=alert-description]:text-success-foreground border-success-foreground',
            primary: 'text-primary bg-primary/5 *:[svg]:text-current *:data-[slot=alert-description]:text-current border-primary',
            warning: 'text-warning-foreground bg-warning/5 *:[svg]:text-current *:data-[slot=alert-description]:text-warning-foreground border-warning-foreground',
            persimmon: 'text-persimmon-foreground bg-persimmon/5 *:[svg]:text-current *:data-[slot=alert-description]:text-persimmon-foreground border-persimmon-foreground',
            danger: 'text-danger-foreground bg-danger/5 *:[svg]:text-current *:data-[slot=alert-description]:text-danger-foreground border-danger-foreground',
            'info-alt2': 'text-info-alt2-foreground bg-info-alt2/5 *:[svg]:text-current *:data-[slot=alert-description]:text-info-alt2-foreground border-info-alt2-foreground',
            muted: 'text-muted-foreground bg-muted',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
function CustomAlert(_a) {
    var className = _a.className, variant = _a.variant, props = __rest(_a, ["className", "variant"]);
    return (<ShadcnAlert className={cn(alertVariants({ variant: variant }), className)} variant={null} // Do not use the primitive variant. Variants are defined and handled here.
     {...props}/>);
}
export { CustomAlert as Alert, AlertAction, AlertDescription, AlertTitle };
